import { createAction } from '@reduxjs/toolkit';

import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const getListGameChangerOutputFilesRequest = (
  entityId,
  yearStart,
  monthStart,
  yearEnd,
  monthEnd,
  limit,
  offset
) =>
  actionRequestFactory(types.GET_LIST_GAME_CHANGER_OUTPUT_FILES_REQUEST, {
    entityId,
    yearStart,
    monthStart,
    yearEnd,
    monthEnd,
    limit,
    offset,
  });

export const getAmazonCentralTransactionsRequest = (entityId, year, month) =>
  actionRequestFactory(types.GET_AMAZON_CENTRAL_TRANSACTIONS_REQUEST, { entityId, year, month });

export const getAmazonCentralTransactionsSuccess = pullResponse =>
  actionResponseFactory(types.GET_AMAZON_CENTRAL_TRANSACTIONS_SUCCESS, { pullResponse });

export const getListGameChangerOutputFilesSuccess = gameChangerFiles =>
  actionResponseFactory(types.GET_LIST_GAME_CHANGER_OUTPUT_FILES_SUCCESS, { gameChangerFiles });

export const getAmazonCentralTransactionsFailure = error =>
  actionResponseFactory(types.GET_AMAZON_CENTRAL_TRANSACTIONS_FAILURE, { error });

export const getListGameChangerOutputFilesFailure = error =>
  actionResponseFactory(types.GET_LIST_GAME_CHANGER_OUTPUT_FILES_FAILURE, { error });

export const downloadGameChangerFile = id =>
  actionRequestFactory(types.DOWNLOAD_GAME_CHANGER_FILE, { id });

export const downloadGameChangerOutputFile = id =>
  actionRequestFactory(types.DOWNLOAD_GAME_CHANGER_OUTPUT_FILE, { id });

export const amazonSellerCentralRequest = (entityId, year, month) =>
  actionRequestFactory(types.GET_AMAZON_SELLER_CENTRAL_REQUEST, { entityId, year, month });

export const getAmazonSellerCentralSuccess = reqHistoryResponse =>
  actionResponseFactory(types.GET_AMAZON_SELLER_CENTRAL_SUCCESS, { reqHistoryResponse });

export const getAmazonSellerCentralFailure = error =>
  actionResponseFactory(types.GET_AMAZON_SELLER_CENTRAL_FAILURE, { error });

export const runGameChangerRequest = (
  entityId,
  year,
  month,
  listCountriesIsoDistanceSellingDestination,
  onSuccess
) =>
  actionRequestFactory(types.RUN_GAME_CHANGER_REQUEST, {
    entityId,
    year,
    month,
    listCountriesIsoDistanceSellingDestination,
    onSuccess,
  });

export const runGameChangerSuccess = response =>
  actionResponseFactory(types.RUN_GAME_CHANGER_SUCCESS, response);

export const runGameChangerFailure = error =>
  actionResponseFactory(types.RUN_GAME_CHANGER_FAILURE, { error });

export const runGameChangerOutputRequest = entityId =>
  actionRequestFactory(types.GET_GAME_CHANGER_OUTPUT_REQUEST, { entityId });

export const runGameChangerOutputSuccess = response =>
  actionResponseFactory(types.GET_GAME_CHANGER_OUTPUT_SUCCESS, { response });

export const runGameChangerOutputFailure = error =>
  actionResponseFactory(types.GET_GAME_CHANGER_OUTPUT_FAILURE, { error });

export const deleteGameChangerOutputFile = id =>
  actionRequestFactory(types.DELETE_GAME_CHANGER_OUTPUT_FILE_REQUEST, { id });

export const deleteGameChangerOutputFileSuccess = response =>
  actionResponseFactory(types.DELETE_GAME_CHANGER_OUTPUT_FILE_SUCCESS, { response });

export const deleteGameChangerOutputFileFailure = error =>
  actionResponseFactory(types.DELETE_GAME_CHANGER_OUTPUT_FILE_FAILURE, { error });

export const postGameChangerOutputFilesRequest = (templateId, files, filingId, mode) =>
  actionRequestFactory(types.POST_GAME_CHANGER_OUTPUT_FILES_REQUEST, {
    outputFiles: {
      game_changer_output_files_assign_list: files,
    },
    templateId,
    filingId,
    mode,
  });

export const postGameChangerOuputFilesSuccess = response =>
  actionResponseFactory(types.POST_GAME_CHANGER_OUTPUT_FILES_SUCCESS, response);

export const postGameChangerOuputFilesFailure = error =>
  actionResponseFactory(types.POST_GAME_CHANGER_OUTPUT_FILES_FAILURE, { error });

export const getGameChangerOutputFileIdsRequest = templateId =>
  actionRequestFactory(types.GAME_CHANGER_OUTPUT_FILE_IDS_REQUEST, { templateId });

export const getGameChangerOutputFileIdsSuccess = response =>
  actionResponseFactory(types.GAME_CHANGER_OUTPUT_FILE_IDS_SUCCESS, response);

export const getGameChangerOutputFileIdsFailure = error =>
  actionResponseFactory(types.GAME_CHANGER_OUTPUT_FILE_IDS_FAILURE, { error });

export const deleteOutputFileRequest = ({ templateId, outputFiles }) =>
  actionRequestFactory(types.DELETE_OUTPUT_FILE_REQUEST, { templateId, outputFiles });

export const deleteOutputFileSuccess = response =>
  actionResponseFactory(types.DELETE_OUTPUT_FILE_SUCCESS, response);

export const deleteOutputFileFailure = response =>
  actionResponseFactory(types.DELETE_OUTPUT_FILE_FAILURE, response);

export const clearGameChangerFiles = () => actionRequestFactory(types.CLEAR_GAME_CHANGER_FILES);

export const gameChangerImportDataRequest = createAction('gameChanger/importRequest');
export const gameChangerImportDataSuccess = createAction('gameChanger/importSuccess');
export const gameChangerImportDataFailure = createAction('gameChanger/importFailure');

export const getListGameChangerFilesRequest = createAction('gameChanger/filesRequest');
export const getListGameChangerFilesSuccess = createAction('gameChanger/filesSuccess');
export const getListGameChangerFilesFailure = createAction('gameChanger/filesFailure');
